module.exports = __webpack_public_path__ + "img/location.5973030d.svg";